import { WorldpayStatus } from './worldpay-status.enum';

export interface WorldpayResult {
  error?: string;
  order: {
    orderKey?: string;
    status: WorldpayStatus;
  };
}
